import script from "./BulkOperationButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./BulkOperationButtons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__